import { cn } from "@/lib/utils";
import GoogleAdsIcon from "@/assets/icons/google_ads.svg";
import MetaIcon from "@/assets/icons/meta.svg";
import TikTokIcon from "@/assets/icons/tiktok.png";
import { Account, PlatformType, AccountStatus } from "@/types";
import { RiGitForkLine } from "@remixicon/react";
import LinkedInIcon from "@/assets/icons/linkedin-logo.png";

export const extendAccountWithIcons = (item: Account) => {
  const newItem: Account = { ...item };
  if (item.type === "MERGED") {
    newItem.labelPrefixIcon = RiGitForkLine;
  } else if (item.platform === PlatformType.FACEBOOK) {
    newItem.labelPrefixIcon = MetaIcon;
  } else if (item.platform === PlatformType.GOOGLE) {
    newItem.labelPrefixIcon = GoogleAdsIcon;
  } else if (item.platform === PlatformType.TIKTOK) {
    newItem.labelPrefixIcon = TikTokIcon;
  } else if (item.platform === PlatformType.LINKEDIN) {
    newItem.labelPrefixIcon = LinkedInIcon;
  }
  newItem.statusIcon = (
    <span
      className={cn(
        "w-2 h-2 rounded-full shrink-0 mt-1.5",
        item.status === AccountStatus.ACTIVE ? "bg-green" : "bg-red",
      )}
    ></span>
  );
  return newItem;
};
